import {Inject, Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs';
import {FrontOrigin} from '../domain/enum/frontOrigin';
import {FRONT_ORIGIN} from '../tokens/frontOrigin.token';

@Injectable({
    providedIn: 'root'
})
export class FrontOriginInterceptor implements HttpInterceptor {
    private static readonly HEADER_NAME = 'X-FRONT-ORIGIN';

    constructor(@Inject(FRONT_ORIGIN) private front: FrontOrigin) {
    }

    public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(
            req.clone({
                headers: req.headers.append(FrontOriginInterceptor.HEADER_NAME, this.front)
            })
        );
    }
}
